export const updateObjectiveMutation = () => {
    return `
    mutation UpdateObjective(
        $objectiveId: Int!,
        $name: String,
        $objectiveNumber: Int,
        $domain: String,
        $domainAbbreviation: String,
        $description: String,
        $risk: String,
        $frequency: String,
        $type: String,
        $itDependency: String,
        $testType: String,
        $specification: String,
        $populationType: String,
        $failureCriteria: String,
        $testPlan: String,
        $abbreviation: String,
        $isKeyObjective: Boolean
    ) {
        updateObjective(
            objectiveId: $objectiveId,
            name: $name,
            objectiveNumber: $objectiveNumber,
            domain: $domain,
            domainAbbreviation: $domainAbbreviation,
            description: $description,
            risk: $risk,
            frequency: $frequency,
            type: $type,
            itDependency: $itDependency,
            testType: $testType,
            specification: $specification,
            populationType: $populationType,
            failureCriteria: $failureCriteria,
            testPlan: $testPlan,
            abbreviation: $abbreviation,
            isKeyObjective: $isKeyObjective
        ) {
            objective {
                id
                name
                objectiveNumber
                domain
                domainAbbreviation
                abbreviation
                description
                risk
                frequency
                type
                ITDependency
                testType
                specification
                populationType
                failureCriteria
                testPlan
                isKeyObjective
            }
        }
    }
    `
}
